import ServiceStorage from "./service-storage";

/**
 * 标注当前类型是一个可注入的服务。
 * @export
 * @returns
 */
export default function injectable() {
    return function (serviceType: Function) {
        ServiceStorage.instance.register(serviceType);
    };
}
